import { Component, OnInit } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { data } from "src/app/audit-trail/application/data";
import { AuditTrailService } from "src/app/audit-trail/audit-trail.service";
import { LotteryFormResponse } from "src/app/model/LotteryFormResponse";
import { ExportImportService } from "src/app/services/export-import.service";
import { PublishLettersService } from "src/app/services/publish-letters.service";
import { ReportService } from "src/app/services/report.service";

@Component({
  selector: "app-secure-update-spouse-pan",
  templateUrl: "./update-spouse-pan.component.html",
  styleUrls: ["./update-spouse-pan.component.scss"],
})
export class UpdateSpousePanDetails implements OnInit {
  [x: string]: any;
  form: FormGroup = new FormGroup({});
  isLoading = false;
  lotteryList: { [key: number]: string };
  isSubmitDisabled: boolean = false;
  downloadedBatches: string[] = [];
  applicationNo: string = "";
  panData: any;

  isUpdatePanDetailsEnable: boolean = false;
  uploadedFile: string | ArrayBuffer;

  selectedFileName: string = "";

  constructor(
    private router: Router,
    private exportImportService: ExportImportService,
    private reportService: ReportService,
    private publishLetterService: PublishLettersService,
    private auditTrailService: AuditTrailService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {

    
    this.publishLetterService.publishDocumentsInitForm().subscribe(
      (data: any) => {
        this.isLoading = false;
        this.lotteryList = data.lotteryList;
      },
      (error) => {
        this.isLoading = false;
        this.publishLetterService.errorToast(
          error.errorMessage || error.error.errorMessage
        );
      }
    );
  }

  refresh() {
    this.loadData();
  }

  refresh1() {
    this.fetchSpousePanDetails();
    // window.location.reload();
  }

  async successToast(msg: any) {
    await this._snackBar.open(msg, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(msg: any) {
    await this._snackBar.open(msg, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
    });
  }

  fetchSpousePanDetails() {
    console.log(this.applicationNo);
    this.isLoading = true;
    this.auditTrailService
      .fetchSpousePanDetailsService({ applicationNo: this.applicationNo })
      .subscribe(
        (data) => {
          console.log(data, "=========>");
          this.isLoading = false;
          this.panData = data;
          // if(data.status === 'SUCCESS') {
          // }
          // else {
          //   this.errorToast("Please Enter correct Application No.");
          //   this.applicationNo ='';
          // }
        },
        (error) => {
          this.isLoading = false;
          this.exportImportService.errorToast(
            "Please Enter correct Application No."
          );
        }
      );
  }

  updateSpousePanDetails() {
    let payload: any = {
      base64File: this.uploadedFile,
      applicationNo: this.applicationNo,
    };

    console.log(payload);

    if (!this.uploadedFile) {
      this.errorMessage = "Please select a file.";
      return;
    }
    console.log(this.applicationNo);
    this.isLoading = true;
    this.auditTrailService.updateSpousePanDetailsService(payload).subscribe(
      (data) => {
        console.log(data, "=========>");
        this.isLoading = false;
        this.panData = data;
        if (data.status === "SUCCESS") {
          this.successToast("Spouse Pan Name Updated Successfully");

          // this.applicationNo ='';
        } else {
          this.errorToast(data.errorMessage);
          this.applicationNo = "";
        }
      },
      (error) => {
        this.isLoading = false;
        this.exportImportService.errorToast(
          error?.error?.message ||
            error?.errorMessage ||
            error?.error?.errorMessage
        );
      }
    );
  }
  toggle(updatePanBtn: any) {
    this.isUpdatePanDetailsEnable = updatePanBtn.checked;
  }

  

  validateInput(event: any): void {
    if(this.panData){
      this.panData = null;
    }
    const input = event.key;
    const isNumeric = /^[0-9]*$/.test(input);
    const isBackspaceOrDelete =
      event.code === "Backspace" || event.code === "Delete";

    // if (!isNumeric && !isBackspaceOrDelete) {
    //   event.preventDefault();
    // }
  }

  onFileSelect(event) {
    this.submitDisabled = true;
    const selectedFile = event.target.files[0];
    if (!selectedFile) {
      this.errorMessage = "Please select a file.";
      return;
    }

    if (selectedFile.type !== "application/pdf") {
      this.errorMessage = "Please select a PDF file only.";
      return;
    }

    this.errorMessage = "";
    this.submitDisabled = false;

    this.selectedFileName = selectedFile.name;

    const reader = new FileReader();
    reader.onload = () => {
      this.uploadedFile = reader.result;
      this.errorMessage = "";
    };

    reader.onerror = () => {
      this.errorMessage = "Error occurred while reading the file.";
    };

    reader.readAsDataURL(selectedFile);
  }
}
